var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"x-data-table-fix-action-col"},[_c('x-data-table',{attrs:{"x-options":_vm.tableOptions,"x-container":_vm.tableContainer,"x-context":_vm.self},scopedSlots:_vm._u([{key:"group.header",fn:function(ref){
var group = ref.group;
var isOpen = ref.isOpen;
var toggle = ref.toggle;
return [_c('td',{staticStyle:{"cursor":"pointer"},attrs:{"colspan":"100%"},on:{"click":toggle}},[_c('v-icon',[_vm._v(_vm._s(isOpen ? "mdi-chevron-up" : "mdi-chevron-down"))]),_c('strong',[_vm._v(_vm._s(group))])],1)]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }